@if (visible()) {
	<div
		role="status"
		aria-live="polite"
		[class]="'flex h-7 justify-center items-center gap-1 text-white md:rounded md:mb-2 ' + colorClass()">
		<ui-icon width="18" height="18" [iconName]="iconName()" />
		<span class="font-bold text-3.25">{{ connectionState.message() }}</span>
	</div>
}
